// window 上回挂载一个initLog方法用于初始化埋点信息
import { awaitScriptLoad } from './report';

/**
 * 初始化埋点
 *
 * @param erp
 */
function initLog(erp: string) {
  (<any>window).initLog && (<any>window).initLog(erp);
  awaitScriptLoad();
}

export default initLog;
